import { Injectable } from '@angular/core';
import { Http, Response, Headers, RequestOptions } from '@angular/http';
import { Observable } from "rxjs/Observable";

import * as globalConst from './../../../constants';

@Injectable()
export class EconomicGroupEditService {

  private apiUrl = globalConst.baseAPI;  // URL para web api  

  constructor(private http: Http) { }

  getEconomicGroups(groupID) {
    return this.http
      .get(this.apiUrl + "/economicgroup/v1/getcodgroup/" + groupID, JSON.parse(localStorage.getItem('yara.connectionHeader')))
      .map((res: Response) => res.json()).catch(e => {
        if (e.status === 401) {
          return Observable.throw('Unauthorized');
        }
      });
  }

  getEconomicGroupsMembers(membersgroup) {
    return this.http
      .post(this.apiUrl + "/groupsmembers/v1/postgroupsdetails/", membersgroup, JSON.parse(localStorage.getItem('yara.connectionHeader')))
      .map((res: Response) => res.json()).catch(e => {
        if (e.status === 401) {
          return Observable.throw('Unauthorized');
        }
      });
  }

  getAprovaGroups(groupID, status: boolean, classificacaoID) {
    return this.http
      .get(this.apiUrl + "/flowgroupaproval/v1/approvalgroup/" + groupID + "/" + status + "/" + classificacaoID, JSON.parse(localStorage.getItem('yara.connectionHeader')))
      .map((res: Response) => res.json()).catch(e => {
        if (e.status === 401) {
          return Observable.throw('Unauthorized');
        }
      });
  }
}






// WEBPACK FOOTER //
// ./src/app/economic-group/service/economic-group-edit.service.ts